// LIBRARIES //
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

// COMPONENTS //
import { RenderGhostError } from 'components/shared/RenderError';

// HELPERS //
import {
  normalizeSin,
  atLeastNineDigitSin,
  normalizeSsn,
  isValidSsn,
  required,
} from 'helpers/Validator';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';

const countries = {
  CANADA: 'Canada',
  USA: 'United States',
};

const sinData = {
  name: 'sinNumber',
  label: 'Sin Number (Optional)',
  normalize: normalizeSin,
  validate: [atLeastNineDigitSin],
};

const ssnData = {
  name: 'ssnNumber',
  label: 'SSN',
  normalize: normalizeSsn,
  validate: [isValidSsn, required],
  required: true,
};

const render = props => {
  const { hide = false, hideError = false, landlordCountry } = props;

  if (hide) {
    return;
  }

  let fieldData = sinData;

  if (landlordCountry === countries.USA) {
    fieldData = ssnData;
  }
  return (
    <Fragment>
      <Field
        name={'sinNumber'}
        type="text"
        component={TextField}
        label={fieldData.label}
        normalize={fieldData.normalize}
        validate={fieldData.validate}
        style={{ fontSize: '14px', width: '100%' }}
        errorStyle={{ fontSize: '12px' }}
        variant="outlined"
      />
      {!hideError && <Field name={fieldData.name} component={RenderGhostError} />}
    </Fragment>
  );
};

export default connect((state, _props) => ({
  landlordCountry: state.userTypes.landlordCountry,
}))(render);
